export default __webpack_public_path__ + "static/cert-3-866e6703b815c526397c45fdfa1451a1.png";